export default __webpack_public_path__ + "static/media/fruits_grapes.f5de6abb.jpeg";